/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VehicleContentRouteImport } from './routes/vehicle-content'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as MagiclinkRouteImport } from './routes/magiclink'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AviseringOmAvfallRouteImport } from './routes/avisering-om-avfall'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ImageIndexRouteImport } from './routes/image.index'
import { Route as VehicleContentQrIdRouteImport } from './routes/vehicle-content-qr.$id'
import { Route as ImageImgRouteImport } from './routes/image.$img'
import { Route as NotFoundRouteImport } from './routes/_.not-found'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app.index'
import { Route as AuthenticatedAppUserschemaRouteImport } from './routes/_authenticated/app.userschema'
import { Route as AuthenticatedAppUppdateringarRouteImport } from './routes/_authenticated/app.uppdateringar'
import { Route as AuthenticatedAppTransportSedlarRouteImport } from './routes/_authenticated/app.transport-sedlar'
import { Route as AuthenticatedAppServiceScheduleRouteImport } from './routes/_authenticated/app.service-schedule'
import { Route as AuthenticatedAppOrganisationRouteImport } from './routes/_authenticated/app.organisation'
import { Route as AuthenticatedAppKontoRouteImport } from './routes/_authenticated/app.konto'
import { Route as AuthenticatedAppKomIgangRouteImport } from './routes/_authenticated/app.kom-igang'
import { Route as AuthenticatedAppFeedbackRouteImport } from './routes/_authenticated/app.feedback'
import { Route as AuthenticatedAppUppdragIndexRouteImport } from './routes/_authenticated/app.uppdrag.index'
import { Route as AuthenticatedAppMottagsstationIndexRouteImport } from './routes/_authenticated/app.mottagsstation.index'
import { Route as AuthenticatedAppKunderIndexRouteImport } from './routes/_authenticated/app.kunder.index'
import { Route as AuthenticatedAppForetagIndexRouteImport } from './routes/_authenticated/app.foretag.index'
import { Route as AuthenticatedAppAvfallsregistretIndexRouteImport } from './routes/_authenticated/app.avfallsregistret.index'
import { Route as AuthenticatedAppSeparatorsSeparatorIdRouteImport } from './routes/_authenticated/app.separators.$separatorId'
import { Route as AuthenticatedAppMottagsstationIdRouteImport } from './routes/_authenticated/app.mottagsstation.$id'
import { Route as AuthenticatedAppForetagCompanyIdRouteImport } from './routes/_authenticated/app.foretag.$companyId'
import { Route as AuthenticatedAppAvfallsregistretRapporteraTransportRouteImport } from './routes/_authenticated/app.avfallsregistret.rapportera-transport'
import { Route as AuthenticatedAppAvfallsregistretRapporteraSomOmbudRouteImport } from './routes/_authenticated/app.avfallsregistret.rapportera-som-ombud'
import { Route as AuthenticatedAppAvfallsregistretIdRouteImport } from './routes/_authenticated/app.avfallsregistret.$id'
import { Route as AuthenticatedAppUppdragUuidIndexRouteImport } from './routes/_authenticated/app.uppdrag.$uuid.index'
import { Route as AuthenticatedAppKunderCustomerIdIndexRouteImport } from './routes/_authenticated/app.kunder.$customerId.index'
import { Route as AuthenticatedAppUppdragUuidTomningWasteIdRouteImport } from './routes/_authenticated/app.uppdrag.$uuid.tomning.$wasteId'
import { Route as AuthenticatedAppUppdragUuidSixmSixmidRouteImport } from './routes/_authenticated/app.uppdrag.$uuid.sixm.$sixmid'
import { Route as AuthenticatedAppUppdragUuidProvtagningPidRouteImport } from './routes/_authenticated/app.uppdrag.$uuid.provtagning.$pid'
import { Route as AuthenticatedAppUppdragUuidFiveyFiveyidRouteImport } from './routes/_authenticated/app.uppdrag.$uuid.fivey.$fiveyid'
import { Route as AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRouteImport } from './routes/_authenticated/app.kunder.$customerId.facility.$facilityId.index'
import { Route as AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRouteImport } from './routes/_authenticated/app.kunder.$customerId.facility.$facilityId.separator.$separatorId'

const VehicleContentRoute = VehicleContentRouteImport.update({
  id: '/vehicle-content',
  path: '/vehicle-content',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const MagiclinkRoute = MagiclinkRouteImport.update({
  id: '/magiclink',
  path: '/magiclink',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AviseringOmAvfallRoute = AviseringOmAvfallRouteImport.update({
  id: '/avisering-om-avfall',
  path: '/avisering-om-avfall',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImageIndexRoute = ImageIndexRouteImport.update({
  id: '/image/',
  path: '/image/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehicleContentQrIdRoute = VehicleContentQrIdRouteImport.update({
  id: '/vehicle-content-qr/$id',
  path: '/vehicle-content-qr/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ImageImgRoute = ImageImgRouteImport.update({
  id: '/image/$img',
  path: '/image/$img',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/_/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppUserschemaRoute =
  AuthenticatedAppUserschemaRouteImport.update({
    id: '/app/userschema',
    path: '/app/userschema',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdateringarRoute =
  AuthenticatedAppUppdateringarRouteImport.update({
    id: '/app/uppdateringar',
    path: '/app/uppdateringar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppTransportSedlarRoute =
  AuthenticatedAppTransportSedlarRouteImport.update({
    id: '/app/transport-sedlar',
    path: '/app/transport-sedlar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppServiceScheduleRoute =
  AuthenticatedAppServiceScheduleRouteImport.update({
    id: '/app/service-schedule',
    path: '/app/service-schedule',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppOrganisationRoute =
  AuthenticatedAppOrganisationRouteImport.update({
    id: '/app/organisation',
    path: '/app/organisation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppKontoRoute = AuthenticatedAppKontoRouteImport.update({
  id: '/app/konto',
  path: '/app/konto',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppKomIgangRoute =
  AuthenticatedAppKomIgangRouteImport.update({
    id: '/app/kom-igang',
    path: '/app/kom-igang',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppFeedbackRoute =
  AuthenticatedAppFeedbackRouteImport.update({
    id: '/app/feedback',
    path: '/app/feedback',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragIndexRoute =
  AuthenticatedAppUppdragIndexRouteImport.update({
    id: '/app/uppdrag/',
    path: '/app/uppdrag/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppMottagsstationIndexRoute =
  AuthenticatedAppMottagsstationIndexRouteImport.update({
    id: '/app/mottagsstation/',
    path: '/app/mottagsstation/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppKunderIndexRoute =
  AuthenticatedAppKunderIndexRouteImport.update({
    id: '/app/kunder/',
    path: '/app/kunder/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppForetagIndexRoute =
  AuthenticatedAppForetagIndexRouteImport.update({
    id: '/app/foretag/',
    path: '/app/foretag/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppAvfallsregistretIndexRoute =
  AuthenticatedAppAvfallsregistretIndexRouteImport.update({
    id: '/app/avfallsregistret/',
    path: '/app/avfallsregistret/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppSeparatorsSeparatorIdRoute =
  AuthenticatedAppSeparatorsSeparatorIdRouteImport.update({
    id: '/app/separators/$separatorId',
    path: '/app/separators/$separatorId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppMottagsstationIdRoute =
  AuthenticatedAppMottagsstationIdRouteImport.update({
    id: '/app/mottagsstation/$id',
    path: '/app/mottagsstation/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppForetagCompanyIdRoute =
  AuthenticatedAppForetagCompanyIdRouteImport.update({
    id: '/app/foretag/$companyId',
    path: '/app/foretag/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppAvfallsregistretRapporteraTransportRoute =
  AuthenticatedAppAvfallsregistretRapporteraTransportRouteImport.update({
    id: '/app/avfallsregistret/rapportera-transport',
    path: '/app/avfallsregistret/rapportera-transport',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute =
  AuthenticatedAppAvfallsregistretRapporteraSomOmbudRouteImport.update({
    id: '/app/avfallsregistret/rapportera-som-ombud',
    path: '/app/avfallsregistret/rapportera-som-ombud',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppAvfallsregistretIdRoute =
  AuthenticatedAppAvfallsregistretIdRouteImport.update({
    id: '/app/avfallsregistret/$id',
    path: '/app/avfallsregistret/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragUuidIndexRoute =
  AuthenticatedAppUppdragUuidIndexRouteImport.update({
    id: '/app/uppdrag/$uuid/',
    path: '/app/uppdrag/$uuid/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppKunderCustomerIdIndexRoute =
  AuthenticatedAppKunderCustomerIdIndexRouteImport.update({
    id: '/app/kunder/$customerId/',
    path: '/app/kunder/$customerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragUuidTomningWasteIdRoute =
  AuthenticatedAppUppdragUuidTomningWasteIdRouteImport.update({
    id: '/app/uppdrag/$uuid/tomning/$wasteId',
    path: '/app/uppdrag/$uuid/tomning/$wasteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragUuidSixmSixmidRoute =
  AuthenticatedAppUppdragUuidSixmSixmidRouteImport.update({
    id: '/app/uppdrag/$uuid/sixm/$sixmid',
    path: '/app/uppdrag/$uuid/sixm/$sixmid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragUuidProvtagningPidRoute =
  AuthenticatedAppUppdragUuidProvtagningPidRouteImport.update({
    id: '/app/uppdrag/$uuid/provtagning/$pid',
    path: '/app/uppdrag/$uuid/provtagning/$pid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppUppdragUuidFiveyFiveyidRoute =
  AuthenticatedAppUppdragUuidFiveyFiveyidRouteImport.update({
    id: '/app/uppdrag/$uuid/fivey/$fiveyid',
    path: '/app/uppdrag/$uuid/fivey/$fiveyid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute =
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRouteImport.update({
    id: '/app/kunder/$customerId/facility/$facilityId/',
    path: '/app/kunder/$customerId/facility/$facilityId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute =
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRouteImport.update(
    {
      id: '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId',
      path: '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/avisering-om-avfall': typeof AviseringOmAvfallRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/magiclink': typeof MagiclinkRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/vehicle-content': typeof VehicleContentRoute
  '/not-found': typeof NotFoundRoute
  '/image/$img': typeof ImageImgRoute
  '/vehicle-content-qr/$id': typeof VehicleContentQrIdRoute
  '/image/': typeof ImageIndexRoute
  '/app/feedback': typeof AuthenticatedAppFeedbackRoute
  '/app/kom-igang': typeof AuthenticatedAppKomIgangRoute
  '/app/konto': typeof AuthenticatedAppKontoRoute
  '/app/organisation': typeof AuthenticatedAppOrganisationRoute
  '/app/service-schedule': typeof AuthenticatedAppServiceScheduleRoute
  '/app/transport-sedlar': typeof AuthenticatedAppTransportSedlarRoute
  '/app/uppdateringar': typeof AuthenticatedAppUppdateringarRoute
  '/app/userschema': typeof AuthenticatedAppUserschemaRoute
  '/app/': typeof AuthenticatedAppIndexRoute
  '/app/avfallsregistret/$id': typeof AuthenticatedAppAvfallsregistretIdRoute
  '/app/avfallsregistret/rapportera-som-ombud': typeof AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute
  '/app/avfallsregistret/rapportera-transport': typeof AuthenticatedAppAvfallsregistretRapporteraTransportRoute
  '/app/foretag/$companyId': typeof AuthenticatedAppForetagCompanyIdRoute
  '/app/mottagsstation/$id': typeof AuthenticatedAppMottagsstationIdRoute
  '/app/separators/$separatorId': typeof AuthenticatedAppSeparatorsSeparatorIdRoute
  '/app/avfallsregistret/': typeof AuthenticatedAppAvfallsregistretIndexRoute
  '/app/foretag/': typeof AuthenticatedAppForetagIndexRoute
  '/app/kunder/': typeof AuthenticatedAppKunderIndexRoute
  '/app/mottagsstation/': typeof AuthenticatedAppMottagsstationIndexRoute
  '/app/uppdrag/': typeof AuthenticatedAppUppdragIndexRoute
  '/app/kunder/$customerId/': typeof AuthenticatedAppKunderCustomerIdIndexRoute
  '/app/uppdrag/$uuid/': typeof AuthenticatedAppUppdragUuidIndexRoute
  '/app/uppdrag/$uuid/fivey/$fiveyid': typeof AuthenticatedAppUppdragUuidFiveyFiveyidRoute
  '/app/uppdrag/$uuid/provtagning/$pid': typeof AuthenticatedAppUppdragUuidProvtagningPidRoute
  '/app/uppdrag/$uuid/sixm/$sixmid': typeof AuthenticatedAppUppdragUuidSixmSixmidRoute
  '/app/uppdrag/$uuid/tomning/$wasteId': typeof AuthenticatedAppUppdragUuidTomningWasteIdRoute
  '/app/kunder/$customerId/facility/$facilityId/': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute
  '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/avisering-om-avfall': typeof AviseringOmAvfallRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/magiclink': typeof MagiclinkRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/vehicle-content': typeof VehicleContentRoute
  '/not-found': typeof NotFoundRoute
  '/image/$img': typeof ImageImgRoute
  '/vehicle-content-qr/$id': typeof VehicleContentQrIdRoute
  '/image': typeof ImageIndexRoute
  '/app/feedback': typeof AuthenticatedAppFeedbackRoute
  '/app/kom-igang': typeof AuthenticatedAppKomIgangRoute
  '/app/konto': typeof AuthenticatedAppKontoRoute
  '/app/organisation': typeof AuthenticatedAppOrganisationRoute
  '/app/service-schedule': typeof AuthenticatedAppServiceScheduleRoute
  '/app/transport-sedlar': typeof AuthenticatedAppTransportSedlarRoute
  '/app/uppdateringar': typeof AuthenticatedAppUppdateringarRoute
  '/app/userschema': typeof AuthenticatedAppUserschemaRoute
  '/app': typeof AuthenticatedAppIndexRoute
  '/app/avfallsregistret/$id': typeof AuthenticatedAppAvfallsregistretIdRoute
  '/app/avfallsregistret/rapportera-som-ombud': typeof AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute
  '/app/avfallsregistret/rapportera-transport': typeof AuthenticatedAppAvfallsregistretRapporteraTransportRoute
  '/app/foretag/$companyId': typeof AuthenticatedAppForetagCompanyIdRoute
  '/app/mottagsstation/$id': typeof AuthenticatedAppMottagsstationIdRoute
  '/app/separators/$separatorId': typeof AuthenticatedAppSeparatorsSeparatorIdRoute
  '/app/avfallsregistret': typeof AuthenticatedAppAvfallsregistretIndexRoute
  '/app/foretag': typeof AuthenticatedAppForetagIndexRoute
  '/app/kunder': typeof AuthenticatedAppKunderIndexRoute
  '/app/mottagsstation': typeof AuthenticatedAppMottagsstationIndexRoute
  '/app/uppdrag': typeof AuthenticatedAppUppdragIndexRoute
  '/app/kunder/$customerId': typeof AuthenticatedAppKunderCustomerIdIndexRoute
  '/app/uppdrag/$uuid': typeof AuthenticatedAppUppdragUuidIndexRoute
  '/app/uppdrag/$uuid/fivey/$fiveyid': typeof AuthenticatedAppUppdragUuidFiveyFiveyidRoute
  '/app/uppdrag/$uuid/provtagning/$pid': typeof AuthenticatedAppUppdragUuidProvtagningPidRoute
  '/app/uppdrag/$uuid/sixm/$sixmid': typeof AuthenticatedAppUppdragUuidSixmSixmidRoute
  '/app/uppdrag/$uuid/tomning/$wasteId': typeof AuthenticatedAppUppdragUuidTomningWasteIdRoute
  '/app/kunder/$customerId/facility/$facilityId': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute
  '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/avisering-om-avfall': typeof AviseringOmAvfallRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/magiclink': typeof MagiclinkRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/vehicle-content': typeof VehicleContentRoute
  '/_/not-found': typeof NotFoundRoute
  '/image/$img': typeof ImageImgRoute
  '/vehicle-content-qr/$id': typeof VehicleContentQrIdRoute
  '/image/': typeof ImageIndexRoute
  '/_authenticated/app/feedback': typeof AuthenticatedAppFeedbackRoute
  '/_authenticated/app/kom-igang': typeof AuthenticatedAppKomIgangRoute
  '/_authenticated/app/konto': typeof AuthenticatedAppKontoRoute
  '/_authenticated/app/organisation': typeof AuthenticatedAppOrganisationRoute
  '/_authenticated/app/service-schedule': typeof AuthenticatedAppServiceScheduleRoute
  '/_authenticated/app/transport-sedlar': typeof AuthenticatedAppTransportSedlarRoute
  '/_authenticated/app/uppdateringar': typeof AuthenticatedAppUppdateringarRoute
  '/_authenticated/app/userschema': typeof AuthenticatedAppUserschemaRoute
  '/_authenticated/app/': typeof AuthenticatedAppIndexRoute
  '/_authenticated/app/avfallsregistret/$id': typeof AuthenticatedAppAvfallsregistretIdRoute
  '/_authenticated/app/avfallsregistret/rapportera-som-ombud': typeof AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute
  '/_authenticated/app/avfallsregistret/rapportera-transport': typeof AuthenticatedAppAvfallsregistretRapporteraTransportRoute
  '/_authenticated/app/foretag/$companyId': typeof AuthenticatedAppForetagCompanyIdRoute
  '/_authenticated/app/mottagsstation/$id': typeof AuthenticatedAppMottagsstationIdRoute
  '/_authenticated/app/separators/$separatorId': typeof AuthenticatedAppSeparatorsSeparatorIdRoute
  '/_authenticated/app/avfallsregistret/': typeof AuthenticatedAppAvfallsregistretIndexRoute
  '/_authenticated/app/foretag/': typeof AuthenticatedAppForetagIndexRoute
  '/_authenticated/app/kunder/': typeof AuthenticatedAppKunderIndexRoute
  '/_authenticated/app/mottagsstation/': typeof AuthenticatedAppMottagsstationIndexRoute
  '/_authenticated/app/uppdrag/': typeof AuthenticatedAppUppdragIndexRoute
  '/_authenticated/app/kunder/$customerId/': typeof AuthenticatedAppKunderCustomerIdIndexRoute
  '/_authenticated/app/uppdrag/$uuid/': typeof AuthenticatedAppUppdragUuidIndexRoute
  '/_authenticated/app/uppdrag/$uuid/fivey/$fiveyid': typeof AuthenticatedAppUppdragUuidFiveyFiveyidRoute
  '/_authenticated/app/uppdrag/$uuid/provtagning/$pid': typeof AuthenticatedAppUppdragUuidProvtagningPidRoute
  '/_authenticated/app/uppdrag/$uuid/sixm/$sixmid': typeof AuthenticatedAppUppdragUuidSixmSixmidRoute
  '/_authenticated/app/uppdrag/$uuid/tomning/$wasteId': typeof AuthenticatedAppUppdragUuidTomningWasteIdRoute
  '/_authenticated/app/kunder/$customerId/facility/$facilityId/': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute
  '/_authenticated/app/kunder/$customerId/facility/$facilityId/separator/$separatorId': typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/avisering-om-avfall'
    | '/forgot-password'
    | '/magiclink'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/vehicle-content'
    | '/not-found'
    | '/image/$img'
    | '/vehicle-content-qr/$id'
    | '/image/'
    | '/app/feedback'
    | '/app/kom-igang'
    | '/app/konto'
    | '/app/organisation'
    | '/app/service-schedule'
    | '/app/transport-sedlar'
    | '/app/uppdateringar'
    | '/app/userschema'
    | '/app/'
    | '/app/avfallsregistret/$id'
    | '/app/avfallsregistret/rapportera-som-ombud'
    | '/app/avfallsregistret/rapportera-transport'
    | '/app/foretag/$companyId'
    | '/app/mottagsstation/$id'
    | '/app/separators/$separatorId'
    | '/app/avfallsregistret/'
    | '/app/foretag/'
    | '/app/kunder/'
    | '/app/mottagsstation/'
    | '/app/uppdrag/'
    | '/app/kunder/$customerId/'
    | '/app/uppdrag/$uuid/'
    | '/app/uppdrag/$uuid/fivey/$fiveyid'
    | '/app/uppdrag/$uuid/provtagning/$pid'
    | '/app/uppdrag/$uuid/sixm/$sixmid'
    | '/app/uppdrag/$uuid/tomning/$wasteId'
    | '/app/kunder/$customerId/facility/$facilityId/'
    | '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/avisering-om-avfall'
    | '/forgot-password'
    | '/magiclink'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/vehicle-content'
    | '/not-found'
    | '/image/$img'
    | '/vehicle-content-qr/$id'
    | '/image'
    | '/app/feedback'
    | '/app/kom-igang'
    | '/app/konto'
    | '/app/organisation'
    | '/app/service-schedule'
    | '/app/transport-sedlar'
    | '/app/uppdateringar'
    | '/app/userschema'
    | '/app'
    | '/app/avfallsregistret/$id'
    | '/app/avfallsregistret/rapportera-som-ombud'
    | '/app/avfallsregistret/rapportera-transport'
    | '/app/foretag/$companyId'
    | '/app/mottagsstation/$id'
    | '/app/separators/$separatorId'
    | '/app/avfallsregistret'
    | '/app/foretag'
    | '/app/kunder'
    | '/app/mottagsstation'
    | '/app/uppdrag'
    | '/app/kunder/$customerId'
    | '/app/uppdrag/$uuid'
    | '/app/uppdrag/$uuid/fivey/$fiveyid'
    | '/app/uppdrag/$uuid/provtagning/$pid'
    | '/app/uppdrag/$uuid/sixm/$sixmid'
    | '/app/uppdrag/$uuid/tomning/$wasteId'
    | '/app/kunder/$customerId/facility/$facilityId'
    | '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/avisering-om-avfall'
    | '/forgot-password'
    | '/magiclink'
    | '/reset-password'
    | '/signin'
    | '/signup'
    | '/vehicle-content'
    | '/_/not-found'
    | '/image/$img'
    | '/vehicle-content-qr/$id'
    | '/image/'
    | '/_authenticated/app/feedback'
    | '/_authenticated/app/kom-igang'
    | '/_authenticated/app/konto'
    | '/_authenticated/app/organisation'
    | '/_authenticated/app/service-schedule'
    | '/_authenticated/app/transport-sedlar'
    | '/_authenticated/app/uppdateringar'
    | '/_authenticated/app/userschema'
    | '/_authenticated/app/'
    | '/_authenticated/app/avfallsregistret/$id'
    | '/_authenticated/app/avfallsregistret/rapportera-som-ombud'
    | '/_authenticated/app/avfallsregistret/rapportera-transport'
    | '/_authenticated/app/foretag/$companyId'
    | '/_authenticated/app/mottagsstation/$id'
    | '/_authenticated/app/separators/$separatorId'
    | '/_authenticated/app/avfallsregistret/'
    | '/_authenticated/app/foretag/'
    | '/_authenticated/app/kunder/'
    | '/_authenticated/app/mottagsstation/'
    | '/_authenticated/app/uppdrag/'
    | '/_authenticated/app/kunder/$customerId/'
    | '/_authenticated/app/uppdrag/$uuid/'
    | '/_authenticated/app/uppdrag/$uuid/fivey/$fiveyid'
    | '/_authenticated/app/uppdrag/$uuid/provtagning/$pid'
    | '/_authenticated/app/uppdrag/$uuid/sixm/$sixmid'
    | '/_authenticated/app/uppdrag/$uuid/tomning/$wasteId'
    | '/_authenticated/app/kunder/$customerId/facility/$facilityId/'
    | '/_authenticated/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AviseringOmAvfallRoute: typeof AviseringOmAvfallRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  MagiclinkRoute: typeof MagiclinkRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  VehicleContentRoute: typeof VehicleContentRoute
  NotFoundRoute: typeof NotFoundRoute
  ImageImgRoute: typeof ImageImgRoute
  VehicleContentQrIdRoute: typeof VehicleContentQrIdRoute
  ImageIndexRoute: typeof ImageIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/vehicle-content': {
      id: '/vehicle-content'
      path: '/vehicle-content'
      fullPath: '/vehicle-content'
      preLoaderRoute: typeof VehicleContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magiclink': {
      id: '/magiclink'
      path: '/magiclink'
      fullPath: '/magiclink'
      preLoaderRoute: typeof MagiclinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/avisering-om-avfall': {
      id: '/avisering-om-avfall'
      path: '/avisering-om-avfall'
      fullPath: '/avisering-om-avfall'
      preLoaderRoute: typeof AviseringOmAvfallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/image/': {
      id: '/image/'
      path: '/image'
      fullPath: '/image/'
      preLoaderRoute: typeof ImageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicle-content-qr/$id': {
      id: '/vehicle-content-qr/$id'
      path: '/vehicle-content-qr/$id'
      fullPath: '/vehicle-content-qr/$id'
      preLoaderRoute: typeof VehicleContentQrIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/image/$img': {
      id: '/image/$img'
      path: '/image/$img'
      fullPath: '/image/$img'
      preLoaderRoute: typeof ImageImgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_/not-found': {
      id: '/_/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/app/': {
      id: '/_authenticated/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof AuthenticatedAppIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/userschema': {
      id: '/_authenticated/app/userschema'
      path: '/app/userschema'
      fullPath: '/app/userschema'
      preLoaderRoute: typeof AuthenticatedAppUserschemaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdateringar': {
      id: '/_authenticated/app/uppdateringar'
      path: '/app/uppdateringar'
      fullPath: '/app/uppdateringar'
      preLoaderRoute: typeof AuthenticatedAppUppdateringarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/transport-sedlar': {
      id: '/_authenticated/app/transport-sedlar'
      path: '/app/transport-sedlar'
      fullPath: '/app/transport-sedlar'
      preLoaderRoute: typeof AuthenticatedAppTransportSedlarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/service-schedule': {
      id: '/_authenticated/app/service-schedule'
      path: '/app/service-schedule'
      fullPath: '/app/service-schedule'
      preLoaderRoute: typeof AuthenticatedAppServiceScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/organisation': {
      id: '/_authenticated/app/organisation'
      path: '/app/organisation'
      fullPath: '/app/organisation'
      preLoaderRoute: typeof AuthenticatedAppOrganisationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/konto': {
      id: '/_authenticated/app/konto'
      path: '/app/konto'
      fullPath: '/app/konto'
      preLoaderRoute: typeof AuthenticatedAppKontoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/kom-igang': {
      id: '/_authenticated/app/kom-igang'
      path: '/app/kom-igang'
      fullPath: '/app/kom-igang'
      preLoaderRoute: typeof AuthenticatedAppKomIgangRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/feedback': {
      id: '/_authenticated/app/feedback'
      path: '/app/feedback'
      fullPath: '/app/feedback'
      preLoaderRoute: typeof AuthenticatedAppFeedbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/': {
      id: '/_authenticated/app/uppdrag/'
      path: '/app/uppdrag'
      fullPath: '/app/uppdrag/'
      preLoaderRoute: typeof AuthenticatedAppUppdragIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/mottagsstation/': {
      id: '/_authenticated/app/mottagsstation/'
      path: '/app/mottagsstation'
      fullPath: '/app/mottagsstation/'
      preLoaderRoute: typeof AuthenticatedAppMottagsstationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/kunder/': {
      id: '/_authenticated/app/kunder/'
      path: '/app/kunder'
      fullPath: '/app/kunder/'
      preLoaderRoute: typeof AuthenticatedAppKunderIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/foretag/': {
      id: '/_authenticated/app/foretag/'
      path: '/app/foretag'
      fullPath: '/app/foretag/'
      preLoaderRoute: typeof AuthenticatedAppForetagIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/avfallsregistret/': {
      id: '/_authenticated/app/avfallsregistret/'
      path: '/app/avfallsregistret'
      fullPath: '/app/avfallsregistret/'
      preLoaderRoute: typeof AuthenticatedAppAvfallsregistretIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/separators/$separatorId': {
      id: '/_authenticated/app/separators/$separatorId'
      path: '/app/separators/$separatorId'
      fullPath: '/app/separators/$separatorId'
      preLoaderRoute: typeof AuthenticatedAppSeparatorsSeparatorIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/mottagsstation/$id': {
      id: '/_authenticated/app/mottagsstation/$id'
      path: '/app/mottagsstation/$id'
      fullPath: '/app/mottagsstation/$id'
      preLoaderRoute: typeof AuthenticatedAppMottagsstationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/foretag/$companyId': {
      id: '/_authenticated/app/foretag/$companyId'
      path: '/app/foretag/$companyId'
      fullPath: '/app/foretag/$companyId'
      preLoaderRoute: typeof AuthenticatedAppForetagCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/avfallsregistret/rapportera-transport': {
      id: '/_authenticated/app/avfallsregistret/rapportera-transport'
      path: '/app/avfallsregistret/rapportera-transport'
      fullPath: '/app/avfallsregistret/rapportera-transport'
      preLoaderRoute: typeof AuthenticatedAppAvfallsregistretRapporteraTransportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/avfallsregistret/rapportera-som-ombud': {
      id: '/_authenticated/app/avfallsregistret/rapportera-som-ombud'
      path: '/app/avfallsregistret/rapportera-som-ombud'
      fullPath: '/app/avfallsregistret/rapportera-som-ombud'
      preLoaderRoute: typeof AuthenticatedAppAvfallsregistretRapporteraSomOmbudRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/avfallsregistret/$id': {
      id: '/_authenticated/app/avfallsregistret/$id'
      path: '/app/avfallsregistret/$id'
      fullPath: '/app/avfallsregistret/$id'
      preLoaderRoute: typeof AuthenticatedAppAvfallsregistretIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/$uuid/': {
      id: '/_authenticated/app/uppdrag/$uuid/'
      path: '/app/uppdrag/$uuid'
      fullPath: '/app/uppdrag/$uuid/'
      preLoaderRoute: typeof AuthenticatedAppUppdragUuidIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/kunder/$customerId/': {
      id: '/_authenticated/app/kunder/$customerId/'
      path: '/app/kunder/$customerId'
      fullPath: '/app/kunder/$customerId/'
      preLoaderRoute: typeof AuthenticatedAppKunderCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/$uuid/tomning/$wasteId': {
      id: '/_authenticated/app/uppdrag/$uuid/tomning/$wasteId'
      path: '/app/uppdrag/$uuid/tomning/$wasteId'
      fullPath: '/app/uppdrag/$uuid/tomning/$wasteId'
      preLoaderRoute: typeof AuthenticatedAppUppdragUuidTomningWasteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/$uuid/sixm/$sixmid': {
      id: '/_authenticated/app/uppdrag/$uuid/sixm/$sixmid'
      path: '/app/uppdrag/$uuid/sixm/$sixmid'
      fullPath: '/app/uppdrag/$uuid/sixm/$sixmid'
      preLoaderRoute: typeof AuthenticatedAppUppdragUuidSixmSixmidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/$uuid/provtagning/$pid': {
      id: '/_authenticated/app/uppdrag/$uuid/provtagning/$pid'
      path: '/app/uppdrag/$uuid/provtagning/$pid'
      fullPath: '/app/uppdrag/$uuid/provtagning/$pid'
      preLoaderRoute: typeof AuthenticatedAppUppdragUuidProvtagningPidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/uppdrag/$uuid/fivey/$fiveyid': {
      id: '/_authenticated/app/uppdrag/$uuid/fivey/$fiveyid'
      path: '/app/uppdrag/$uuid/fivey/$fiveyid'
      fullPath: '/app/uppdrag/$uuid/fivey/$fiveyid'
      preLoaderRoute: typeof AuthenticatedAppUppdragUuidFiveyFiveyidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/kunder/$customerId/facility/$facilityId/': {
      id: '/_authenticated/app/kunder/$customerId/facility/$facilityId/'
      path: '/app/kunder/$customerId/facility/$facilityId'
      fullPath: '/app/kunder/$customerId/facility/$facilityId/'
      preLoaderRoute: typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/app/kunder/$customerId/facility/$facilityId/separator/$separatorId': {
      id: '/_authenticated/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
      path: '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
      fullPath: '/app/kunder/$customerId/facility/$facilityId/separator/$separatorId'
      preLoaderRoute: typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAppFeedbackRoute: typeof AuthenticatedAppFeedbackRoute
  AuthenticatedAppKomIgangRoute: typeof AuthenticatedAppKomIgangRoute
  AuthenticatedAppKontoRoute: typeof AuthenticatedAppKontoRoute
  AuthenticatedAppOrganisationRoute: typeof AuthenticatedAppOrganisationRoute
  AuthenticatedAppServiceScheduleRoute: typeof AuthenticatedAppServiceScheduleRoute
  AuthenticatedAppTransportSedlarRoute: typeof AuthenticatedAppTransportSedlarRoute
  AuthenticatedAppUppdateringarRoute: typeof AuthenticatedAppUppdateringarRoute
  AuthenticatedAppUserschemaRoute: typeof AuthenticatedAppUserschemaRoute
  AuthenticatedAppIndexRoute: typeof AuthenticatedAppIndexRoute
  AuthenticatedAppAvfallsregistretIdRoute: typeof AuthenticatedAppAvfallsregistretIdRoute
  AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute: typeof AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute
  AuthenticatedAppAvfallsregistretRapporteraTransportRoute: typeof AuthenticatedAppAvfallsregistretRapporteraTransportRoute
  AuthenticatedAppForetagCompanyIdRoute: typeof AuthenticatedAppForetagCompanyIdRoute
  AuthenticatedAppMottagsstationIdRoute: typeof AuthenticatedAppMottagsstationIdRoute
  AuthenticatedAppSeparatorsSeparatorIdRoute: typeof AuthenticatedAppSeparatorsSeparatorIdRoute
  AuthenticatedAppAvfallsregistretIndexRoute: typeof AuthenticatedAppAvfallsregistretIndexRoute
  AuthenticatedAppForetagIndexRoute: typeof AuthenticatedAppForetagIndexRoute
  AuthenticatedAppKunderIndexRoute: typeof AuthenticatedAppKunderIndexRoute
  AuthenticatedAppMottagsstationIndexRoute: typeof AuthenticatedAppMottagsstationIndexRoute
  AuthenticatedAppUppdragIndexRoute: typeof AuthenticatedAppUppdragIndexRoute
  AuthenticatedAppKunderCustomerIdIndexRoute: typeof AuthenticatedAppKunderCustomerIdIndexRoute
  AuthenticatedAppUppdragUuidIndexRoute: typeof AuthenticatedAppUppdragUuidIndexRoute
  AuthenticatedAppUppdragUuidFiveyFiveyidRoute: typeof AuthenticatedAppUppdragUuidFiveyFiveyidRoute
  AuthenticatedAppUppdragUuidProvtagningPidRoute: typeof AuthenticatedAppUppdragUuidProvtagningPidRoute
  AuthenticatedAppUppdragUuidSixmSixmidRoute: typeof AuthenticatedAppUppdragUuidSixmSixmidRoute
  AuthenticatedAppUppdragUuidTomningWasteIdRoute: typeof AuthenticatedAppUppdragUuidTomningWasteIdRoute
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute: typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute: typeof AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppFeedbackRoute: AuthenticatedAppFeedbackRoute,
  AuthenticatedAppKomIgangRoute: AuthenticatedAppKomIgangRoute,
  AuthenticatedAppKontoRoute: AuthenticatedAppKontoRoute,
  AuthenticatedAppOrganisationRoute: AuthenticatedAppOrganisationRoute,
  AuthenticatedAppServiceScheduleRoute: AuthenticatedAppServiceScheduleRoute,
  AuthenticatedAppTransportSedlarRoute: AuthenticatedAppTransportSedlarRoute,
  AuthenticatedAppUppdateringarRoute: AuthenticatedAppUppdateringarRoute,
  AuthenticatedAppUserschemaRoute: AuthenticatedAppUserschemaRoute,
  AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,
  AuthenticatedAppAvfallsregistretIdRoute:
    AuthenticatedAppAvfallsregistretIdRoute,
  AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute:
    AuthenticatedAppAvfallsregistretRapporteraSomOmbudRoute,
  AuthenticatedAppAvfallsregistretRapporteraTransportRoute:
    AuthenticatedAppAvfallsregistretRapporteraTransportRoute,
  AuthenticatedAppForetagCompanyIdRoute: AuthenticatedAppForetagCompanyIdRoute,
  AuthenticatedAppMottagsstationIdRoute: AuthenticatedAppMottagsstationIdRoute,
  AuthenticatedAppSeparatorsSeparatorIdRoute:
    AuthenticatedAppSeparatorsSeparatorIdRoute,
  AuthenticatedAppAvfallsregistretIndexRoute:
    AuthenticatedAppAvfallsregistretIndexRoute,
  AuthenticatedAppForetagIndexRoute: AuthenticatedAppForetagIndexRoute,
  AuthenticatedAppKunderIndexRoute: AuthenticatedAppKunderIndexRoute,
  AuthenticatedAppMottagsstationIndexRoute:
    AuthenticatedAppMottagsstationIndexRoute,
  AuthenticatedAppUppdragIndexRoute: AuthenticatedAppUppdragIndexRoute,
  AuthenticatedAppKunderCustomerIdIndexRoute:
    AuthenticatedAppKunderCustomerIdIndexRoute,
  AuthenticatedAppUppdragUuidIndexRoute: AuthenticatedAppUppdragUuidIndexRoute,
  AuthenticatedAppUppdragUuidFiveyFiveyidRoute:
    AuthenticatedAppUppdragUuidFiveyFiveyidRoute,
  AuthenticatedAppUppdragUuidProvtagningPidRoute:
    AuthenticatedAppUppdragUuidProvtagningPidRoute,
  AuthenticatedAppUppdragUuidSixmSixmidRoute:
    AuthenticatedAppUppdragUuidSixmSixmidRoute,
  AuthenticatedAppUppdragUuidTomningWasteIdRoute:
    AuthenticatedAppUppdragUuidTomningWasteIdRoute,
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute:
    AuthenticatedAppKunderCustomerIdFacilityFacilityIdIndexRoute,
  AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute:
    AuthenticatedAppKunderCustomerIdFacilityFacilityIdSeparatorSeparatorIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AviseringOmAvfallRoute: AviseringOmAvfallRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  MagiclinkRoute: MagiclinkRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  VehicleContentRoute: VehicleContentRoute,
  NotFoundRoute: NotFoundRoute,
  ImageImgRoute: ImageImgRoute,
  VehicleContentQrIdRoute: VehicleContentQrIdRoute,
  ImageIndexRoute: ImageIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
